const ColorsRoutes = {
    createColor: "admin/create-color",
    getColors: "admin/get-colors",
    deleteColor: "admin/delete-color/",
    updateColor: "admin/update-color/",
}

export default ColorsRoutes